module.exports = __webpack_public_path__ + "img/gunther_kolvenbach.8f9a3e3a.png";